import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import clientSvc from '../../../services/client/clientSvc';
import {
  ClientsResponse,
  IClientsPagination,
} from '../../../services/client/types';
import { QueryParams } from '../../../services/types';
import { LoadState } from '../../store/types';

type ClientsState = LoadState<IClientsPagination>;

export const initialState: ClientsState = {
  error: '',
  loading: false,
  data: null,
};

const fetchClients = createAsyncThunk(
  'fetchClients',
  async (params: QueryParams, thunk) => {
    const { getState } = thunk;
    const currentState = getState() as RootState;
    const company = currentState.profile.data?.company;
    if (company?.enterpriseId) {
      return clientSvc.getContacts<ClientsResponse>({
        params,
        enterpriseId: company.enterpriseId,
      });
    }
    return { results: [] } as unknown as ClientsResponse;
  }
);

export const clientsStatus = createSlice({
  name: 'clients',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchClients.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchClients.fulfilled, (state, { payload: clients }) => {
      state.loading = false;
      state.data = clients;
      state.error = '';
    });

    builder.addCase(fetchClients.rejected, (state) => {
      state.loading = false;
      state.data = null;
      state.error = 'ERROR';
    });
  },
});

export { fetchClients };
export default clientsStatus.reducer;
